import { Component } from '@angular/core';
import { TourStepId } from '../../core/models/enums/tour-step-id.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false,
})
export class HomeComponent {
  readonly TourStepId = TourStepId;
}
